import { QueryClient } from "@tanstack/vue-query";

/**
 * Global QueryClient instance to be shared among the apps and libs;
 * ensures a single query cache across all mounted Vue roots on a page.
 */
const queryClient = new QueryClient();

export { queryClient };
